module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Проекты'
      }
    }
  }, [_vm._v("Проекты")])], 1), _vm._v(" "), _c('span', [_vm._v("/"), _c('b', [_vm._v(" Вывод средств ")])]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('h1', [_vm._v(" Вывод средств ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "my-5": ""
    }
  }, [_c('div', [_vm._v("\n      Вывод средств осуществляется на тот же счет, откуда было пополнение.\n    ")]), _vm._v(" "), _c('div', [_vm._v("\n      Для вывода, необходимо заполнить заявку, после обработки которой, будет осуществлен перевод средств.\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9848198a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountWithdraw.vue
// module id = 468
// module chunks = 1